import { useState } from "react";
import { useDispatch } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";
import { UnarchiveTwoTone } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

import { CustomAlert, CustomButton } from "../../../../../shared/uiComponents";
import { errorNormalizer } from "../../../../../shared/Helpers/functions";
import { ButtonWrapper } from "../../../../../components/StyledComponents";

import { DispatchProperties } from "../../../../../redux/store";
import { ProgramProperties } from "../../../../../redux/API/ClientAPIHelpers/clientProgramProperties";
import {
  getPrograms,
  unarchiveProgram,
} from "../../../../../redux/State/clientSlice/clientProgramSlice";

const Unarchive = ({ data }: { data: ProgramProperties }) => {
  const [open, setOpen] = useState<boolean>(false);
  const closeHandler = () => setOpen(false);
  return (
    <>
      <Tooltip title="Unarchive">
        <UnarchiveTwoTone onClick={() => setOpen(true)} />
      </Tooltip>
      <CustomAlert
        title="Do you want to unarchive?"
        open={open}
        onClose={closeHandler}
        Content={({ onClose }) => (
          <UnarchiveContent data={data} onClose={onClose} />
        )}
      />
    </>
  );
};

const UnarchiveContent = ({
  data,
  onClose,
}: {
  data: ProgramProperties;
  onClose: () => void;
}) => {
  const dispatch = useDispatch<DispatchProperties>();

  const unarchiveHandler = () => {
    dispatch(unarchiveProgram(data))
      .then(unwrapResult)
      .then(() => {
        dispatch(getPrograms({ skillAreaId: data.skillAreaId }));
        onClose();
      })
      .catch(errorNormalizer);
  };

  return (
    <ButtonWrapper>
      <CustomButton title="Yes" onClick={unarchiveHandler} />
      <CustomButton title="Cancel" secondaryButton onClick={onClose} />
    </ButtonWrapper>
  );
};

export default Unarchive;
